export const categories = [
  { slug: "all", name: "全部", icon: "ri-movie-2-line" },
  { slug: "action", name: "动作片", icon: "ri-fire-line" },
  { slug: "comedy", name: "喜剧片", icon: "ri-emotion-laugh-line" },
  { slug: "drama", name: "剧情片", icon: "ri-heart-line" },
  { slug: "scifi", name: "科幻片", icon: "ri-rocket-line" },
  { slug: "horror", name: "恐怖片", icon: "ri-ghost-line" },
  { slug: "romance", name: "爱情片", icon: "ri-heart-pulse-line" },
  { slug: "animation", name: "动画片", icon: "ri-bear-smile-line" },
  { slug: "documentary", name: "纪录片", icon: "ri-camera-line" },
  { slug: "suspense", name: "悬疑片", icon: "ri-search-eye-line" },
];

export const movies = [
  {
    id: 1,
    title: "星际穿越",
    titleEn: "Interstellar",
    year: 2014,
    rating: 9.4,
    category: "scifi",
    director: "克里斯托弗·诺兰",
    actors: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦"],
    description: "一队探险家利用他们针对虫洞的新发现，超越人类对于太空旅行的极限，从而开始在广袤的宇宙中进行星际航行的故事。",
    duration: "169分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Interstellar%20movie%20poster%20style%2C%20vast%20dark%20space%20with%20glowing%20warm%20wormhole%20light%2C%20cinematic%20dramatic%20lighting%2C%20deep%20space%20background%20with%20stars%2C%20epic%20film%20aesthetic%2C%20dark%20tone%20with%20golden%20accents%2C%20minimal%20poster%20design&width=600&height=900&seq=movie-card-1&orientation=portrait",
    tags: ["必看经典", "IMAX", "科幻神作"],
  },
  {
    id: 2,
    title: "肖申克的救赎",
    titleEn: "The Shawshank Redemption",
    year: 1994,
    rating: 9.7,
    category: "drama",
    director: "弗兰克·德拉邦特",
    actors: ["蒂姆·罗宾斯", "摩根·弗里曼"],
    description: "一个银行家因被误判杀害妻子及其情人而被关进肖申克监狱，在狱中他凭借才智和毅力赢得了尊重，最终以惊人的方式重获自由。",
    duration: "142分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Shawshank%20Redemption%20movie%20poster%2C%20warm%20golden%20light%20through%20rain%20scene%2C%20hopeful%20cinematic%20atmosphere%2C%20dark%20silhouettes%20against%20warm%20amber%20sky%2C%20dramatic%20film%20aesthetic%2C%20minimal%20poster%20design%20with%20deep%20emotional%20tone&width=600&height=900&seq=movie-card-2&orientation=portrait",
    tags: ["影史第一", "励志", "经典"],
  },
  {
    id: 3,
    title: "流浪地球2",
    titleEn: "The Wandering Earth II",
    year: 2023,
    rating: 8.3,
    category: "scifi",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启了充满危机的流浪地球计划。",
    duration: "173分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20The%20Wandering%20Earth%20poster%2C%20massive%20planetary%20engines%20firing%20against%20dark%20space%20background%2C%20blue%20and%20orange%20contrast%20lighting%2C%20epic%20scale%20cinematic%20design%2C%20futuristic%20industrial%20aesthetic%2C%20dramatic%20composition&width=600&height=900&seq=movie-card-3&orientation=portrait",
    tags: ["国产科幻", "硬核科幻", "太空"],
  },
  {
    id: 4,
    title: "疯狂动物城",
    titleEn: "Zootopia",
    year: 2016,
    rating: 9.2,
    category: "animation",
    director: "拜伦·霍华德",
    actors: ["金妮弗·古德温", "杰森·贝特曼"],
    description: "在一个所有动物和平共处的动物城市，兔子朱迪通过努力奋斗完成了儿时的梦想，成为动物警察。",
    duration: "109分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Zootopia%20animated%20movie%20poster%2C%20vibrant%20colorful%20city%20skyline%20background%2C%20anthropomorphic%20fox%20and%20rabbit%20duo%2C%20warm%20and%20bright%20lighting%2C%20playful%20Disney%20aesthetic%2C%20rich%20color%20palette%20with%20modern%20urban%20feel&width=600&height=900&seq=movie-card-4&orientation=portrait",
    tags: ["动画经典", "迪士尼", "合家欢"],
  },
  {
    id: 5,
    title: "盗梦空间",
    titleEn: "Inception",
    year: 2010,
    rating: 9.3,
    category: "suspense",
    director: "克里斯托弗·诺兰",
    actors: ["莱昂纳多·迪卡普里奥", "约瑟夫·戈登-莱维特"],
    description: "一位专业的窃贼在人们的梦境中窃取机密，为了回到孩子们身边，他必须完成一项看似不可能的任务——在梦境中植入一个想法。",
    duration: "148分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Inception%20movie%20poster%20style%2C%20surreal%20dreamscape%20city%20folding%20upon%20itself%2C%20dark%20moody%20atmosphere%20with%20subtle%20golden%20light%2C%20cerebral%20sci-fi%20thriller%20aesthetic%2C%20mind-bending%20visual%20concept%2C%20clean%20minimal%20poster%20composition&width=600&height=900&seq=movie-card-5&orientation=portrait",
    tags: ["烧脑神作", "科幻", "诺兰"],
  },
  {
    id: 6,
    title: "你的名字。",
    titleEn: "Your Name.",
    year: 2016,
    rating: 8.4,
    category: "romance",
    director: "新海诚",
    actors: ["神木隆之介", "上白石萌音"],
    description: "在乡下生活的三叶和东京高中生�的�的梦中交换了身体，两人在体验对方生活的同时，一段跨越时空的爱情故事悄然展开。",
    duration: "106分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Your%20Name%20anime%20movie%20poster%2C%20beautiful%20twilight%20sky%20with%20comet%20streaking%20across%2C%20starry%20night%20atmosphere%2C%20soft%20purple%20and%20orange%20gradient%20lighting%2C%20romantic%20Japanese%20animation%20aesthetic%2C%20dreamy%20emotional%20composition&width=600&height=900&seq=movie-card-6&orientation=portrait",
    tags: ["动画", "爱情", "治愈"],
  },
  {
    id: 7,
    title: "饥饿游戏",
    titleEn: "The Hunger Games",
    year: 2012,
    rating: 7.0,
    category: "action",
    director: "加里·罗斯",
    actors: ["詹妮弗·劳伦斯", "乔什·哈切森"],
    description: "在一个反乌托邦的未来世界，12个区的少男少女被选中参加一年一度的饥饿游戏，在电视直播中相互厮杀直至仅剩一人生还。",
    duration: "142分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Hunger%20Games%20movie%20poster%20aesthetic%2C%20heroine%20with%20bow%20against%20dark%20dystopian%20background%2C%20fiery%20warm%20golden%20tones%2C%20dramatic%20cinematic%20lighting%2C%20strong%20female%20lead%2C%20action%20film%20poster%20design%20with%20intensity&width=600&height=900&seq=movie-card-7&orientation=portrait",
    tags: ["反乌托邦", "动作", "冒险"],
  },
  {
    id: 8,
    title: "招魂",
    titleEn: "The Conjuring",
    year: 2013,
    rating: 7.9,
    category: "horror",
    director: "温子仁",
    actors: ["维拉·法米加", "帕特里克·威尔森"],
    description: "一对夫妇带着五个女儿搬进一座古老的农舍，随后发生了一系列超自然事件，他们请来了著名的驱魔师沃伦夫妇帮忙。",
    duration: "112分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=The%20Conjuring%20horror%20movie%20poster%20style%2C%20old%20haunted%20farmhouse%20in%20dark%20misty%20atmosphere%2C%20cold%20blue%20moonlight%20contrasting%20warm%20window%20light%2C%20supernatural%20thriller%20aesthetic%2C%20eerie%20and%20unsettling%20composition%2C%20dark%20tones&width=600&height=900&seq=movie-card-8&orientation=portrait",
    tags: ["恐怖经典", "超自然", "温子仁"],
  },
  {
    id: 9,
    title: "功夫",
    titleEn: "Kung Fu Hustle",
    year: 2004,
    rating: 8.6,
    category: "comedy",
    director: "周星驰",
    actors: ["周星驰", "元秋", "元华"],
    description: "在1940年代的上海，小混混阿星误闯猪笼城寨，卷入了租界黑帮和隐居武林高手之间的大战，最后激发了自己的武学天赋。",
    duration: "99分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Kung%20Fu%20Hustle%20movie%20poster%2C%20retro%201940s%20Shanghai%20street%20scene%2C%20dynamic%20martial%20arts%20action%20with%20comedic%20twist%2C%20warm%20sepia%20tones%20with%20bold%20red%20accents%2C%20classic%20Hong%20Kong%20cinema%20aesthetic%2C%20energetic%20and%20playful%20composition&width=600&height=900&seq=movie-card-9&orientation=portrait",
    tags: ["经典喜剧", "动作", "周星驰"],
  },
  {
    id: 10,
    title: "我不是药神",
    titleEn: "Dying to Survive",
    year: 2018,
    rating: 9.0,
    category: "drama",
    director: "文牧野",
    actors: ["徐峥", "周一围", "王传君"],
    description: "一位保健品店主从印度代购白血病仿制药，救助了一批白血病患者，却也因此卷入法律纠纷的感人故事。",
    duration: "117分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20drama%20film%20Dying%20to%20Survive%20poster%2C%20group%20of%20determined%20characters%20standing%20together%2C%20warm%20earthy%20tones%2C%20realistic%20urban%20background%2C%20heartfelt%20social%20commentary%20aesthetic%2C%20humanistic%20portrait%20composition&width=600&height=900&seq=movie-card-10&orientation=portrait",
    tags: ["国产佳片", "现实题材", "感人"],
  },
  {
    id: 11,
    title: "阿凡达",
    titleEn: "Avatar",
    year: 2009,
    rating: 8.7,
    category: "scifi",
    director: "詹姆斯·卡梅隆",
    actors: ["萨姆·沃辛顿", "佐伊·索尔达娜"],
    description: "一名前海军陆战队员被派往潘多拉星球，在那里他融入纳美族的生活，并最终带领他们抵抗人类入侵。",
    duration: "162分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Avatar%20movie%20poster%20style%2C%20bioluminescent%20alien%20forest%20with%20glowing%20plants%20at%20night%2C%20ethereal%20blue%20and%20purple%20tones%2C%20magical%20fantasy%20world%2C%20epic%20cinematic%20aesthetic%2C%20immersive%203D%20film%20design&width=600&height=900&seq=movie-card-11&orientation=portrait",
    tags: ["3D里程碑", "科幻", "冒险"],
  },
  {
    id: 12,
    title: "千与千寻",
    titleEn: "Spirited Away",
    year: 2001,
    rating: 9.4,
    category: "animation",
    director: "宫崎骏",
    actors: ["柊瑠美", "入野自由"],
    description: "10岁少女千寻在搬家途中误入一个神灵世界，为了拯救变成猪的父母，她必须在这个奇幻世界中工作和生存。",
    duration: "125分钟",
    posterUrl: "https://readdy.ai/api/search-image?query=Spirited%20Away%20Studio%20Ghibli%20movie%20poster%2C%20magical%20bathhouse%20with%20warm%20glowing%20lanterns%20at%20night%2C%20surreal%20Japanese%20spirit%20world%2C%20rich%20red%20and%20gold%20color%20palette%2C%20enchanting%20fantasy%20anime%20aesthetic%2C%20dreamlike%20composition&width=600&height=900&seq=movie-card-12&orientation=portrait",
    tags: ["宫崎骏", "奥斯卡", "经典动画"],
  },
];

export const bannerMovies = [
  {
    id: 13,
    title: "奥本海默",
    titleEn: "Oppenheimer",
    year: 2023,
    rating: 8.8,
    category: "drama",
    director: "克里斯托弗·诺兰",
    description: "讲述了美国原子弹之父罗伯特·奥本海默主导制造出世界上第一颗原子弹的故事。",
    bannerUrl: "https://readdy.ai/api/search-image?query=Oppenheimer%20movie%20banner%20cinematic%2C%20intense%20closeup%20of%20scientist%20against%20massive%20nuclear%20explosion%2C%20dramatic%20orange%20and%20black%20contrast%2C%20powerful%20moody%20atmosphere%2C%20historical%20epic%20film%20aesthetic%2C%20wide%20cinematic%20composition%20with%20dark%20tones%20and%20fiery%20warm%20light&width=1920&height=900&seq=hero-banner-13&orientation=landscape",
    tags: ["诺兰新作", "传记", "历史"],
  },
  {
    id: 14,
    title: "蜘蛛侠：纵横宇宙",
    titleEn: "Spider-Man: Across the Spider-Verse",
    year: 2023,
    rating: 8.6,
    category: "animation",
    director: "乔伊姆·多斯·桑托斯",
    description: "迈尔斯踏上跨越多元宇宙的全新旅程，与蜘蛛侠联盟一起对抗一个强大的新威胁。",
    bannerUrl: "https://readdy.ai/api/search-image?query=Spider-Man%20Across%20the%20Spider-Verse%20movie%20banner%2C%20multiple%20Spider-Man%20characters%20leaping%20across%20vibrant%20neon%20cityscape%2C%20dynamic%20comic%20book%20style%2C%20explosive%20colors%20with%20deep%20blacks%2C%20groundbreaking%20animation%20aesthetic%2C%20energetic%20wide%20composition&width=1920&height=900&seq=hero-banner-14&orientation=landscape",
    tags: ["动画革新", "漫威", "多元宇宙"],
  },
  {
    id: 15,
    title: "封神第一部",
    titleEn: "Creation of the Gods I",
    year: 2023,
    rating: 7.8,
    category: "action",
    director: "乌尔善",
    description: "商王殷寿与狐妖妲己勾结，暴虐无道引发天谴，昆仑仙人姜子牙携封神榜下山寻找天下共主以救苍生。",
    bannerUrl: "https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20film%20Creation%20of%20the%20Gods%20movie%20banner%2C%20ancient%20Chinese%20warriors%20in%20battle%20stance%2C%20mythological%20atmosphere%20with%20golden%20divine%20light%2C%20grand%20scale%20historical%20fantasy%2C%20dramatic%20warm%20tones%20with%20dark%20epic%20sky%2C%20majestic%20cinematic%20composition&width=1920&height=900&seq=hero-banner-15&orientation=landscape",
    tags: ["国产大片", "神话", "史诗"],
  },
];

export const hotRanking = [1, 2, 3, 5, 4, 6, 9, 10, 12, 7];